import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { RedirectionState, RedirectionStateSelector } from '../store';



@Injectable({providedIn: 'root'})
export class RedirectionService {
  redirectionInfo$: Observable<RedirectionState>;

  constructor(private store$: Store<RedirectionState>) {
    this.redirectionInfo$ = store$.pipe(select(RedirectionStateSelector.getRedirectionInfo));
  }

}
